import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

/**
 * Shows "typed/limit" on a field's label row (KOR-15210), so a customer sees the limit before typing stops at it.
 * Wraps the field-wrapper: `wrappers: ['character-count', 'field-wrapper']`, with `props.maxLength` set.
 */
@Component({
  selector: 'app-character-count-wrapper',
  template: `
    <div class="character-count-field">
      <ng-container #fieldComponent></ng-container>
      @if (props.maxLength) {
        <span class="character-count" aria-hidden="true">{{ length }}/{{ props.maxLength }}</span>
      }
    </div>
  `,
  styleUrls: ['./character-count-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class CharacterCountWrapperComponent extends FieldWrapper {
  get length(): number {
    const value: unknown = this.formControl.value;
    return typeof value === 'string' ? value.length : 0;
  }
}
